import { render } from "./home.vue?vue&type=template&id=66bada18&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=66bada18&lang=scss&scoped=true"
import "./home.vue?vue&type=style&index=1&id=66bada18&lang=css"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bada18"]])

export default __exports__